import moment from "moment";

const historyTable = [
  {
    identifier: "paper_trail/versions",
    label: "History",
    accessor: (dataObject) => (dataObject?.versions ? dataObject?.versions : []),
    type: "table",
    hideInCreate: true,
    hideInEdit: true,
    lgCol: 12,
    mdCol: 12,
    fields: [
      {
        identifier: "id",
        label: "Version ID",
        accessor: "id",
        inList: true,
        hideInCreate: true,
        hideInEdit: true,
      },
      {
        identifier: "whodunnit",
        accessor: (dataObject) => (dataObject?.whodunnit ? dataObject?.whodunnit : "_"),
        label: "Updater",
        type: "string",
        hideInCreate: true,
        hideInEdit: true,
        inList: true,
      },
      {
        identifier: "event",
        accessor: "event",
        label: "Event",
        hideInCreate: true,
        hideInEdit: true,
        inList: true,
      },
      {
        identifier: "source",
        accessor: (dataObject) => (dataObject?.source ? dataObject?.source : "_"),
        label: "Source",
        hideInCreate: true,
        hideInEdit: true,
        inList: true,
        type: "string",
      },
      {
        identifier: "created_at",
        accessor: (dataObject) => (dataObject?.created_at ? moment(dataObject.created_at).format("lll") : null),
        label: "Date",
        hideInCreate: true,
        hideInEdit: true,
        inList: true,
      },
    ],
    tableConfig: {
      name: "company",
      type: "static",
      import: undefined,
    },
  },
];

export default historyTable;
